import { Col } from "react-bootstrap";
import { Box } from "../../../components/box";
import { Icon } from "../../../components/icon";
import React, { useMemo, useState } from "react";
import { withStatisticWapper } from "../statistics";
import { useHistory, useLocation } from "react-router-dom";
import { getDDMMYYYFormat, isDocumentExpired } from "../../../helper/dateTimeHelper";
import { TableHelpers } from "../../../helper/TableHelper";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { ColumnsType } from "antd/lib/table";
import { Button, Checkbox, Typography } from "antd";
import { Table } from "../../../components";

export const StatisticDocumentByViagsPage = withStatisticWapper(() => {
  // const [documentInfo, setDocumentInfo] = useState<any>([]);
  const [isColunmVisible, setColunmVisible] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();
  
  const { documentInfo, title } = location.state as {
    documentInfo: any;
    title: string;
    isCompose: boolean;
  };

  const mappedData = useMemo(
    () => documentInfo.map((e: any, index: number) => ({ index: index + 1, ...e })),
    [documentInfo],
  );

  const titleOfExcelFile = "Danh sách tài liệu đã triển khai trong kỳ";

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();

    let result: any = mappedData?.map((dbp: any) => {
      const percentage = ((dbp.docReaders?.length ?? 0) / (dbp.docPublicEndUsers?.length ?? 1)) * 100;
      const unreadPercentage =
        (((dbp.docPublicEndUsers?.length ?? 0) - (dbp.docReaders?.length ?? 0)) /
          (dbp.docPublicEndUsers?.length ?? 1)) *
        100;
      return {
        docCode: dbp.docCode,
        Title: dbp.Title,
        docType: dbp.docType,
        docStatus: dbp.docStatus,
        effectiveFrom: getDDMMYYYFormat(dbp.effectiveFrom),
        quantityRead: dbp.docReaders?.length ?? 0,
        readedPercent: percentage % 1 === 0 ? percentage + "%" : percentage.toFixed(2) + "%",
        quantityUnread: (dbp.docPublicEndUsers?.length ?? 0) - (dbp.docReaders?.length ?? 0),
        unreadPercent: unreadPercentage % 1 === 0 ? unreadPercentage + "%" : unreadPercentage.toFixed(2) + "%",
        createdDateTime: getDDMMYYYFormat(dbp.createdDateTime),
        effectiveTo: getDDMMYYYFormat(dbp.effectiveTo),
      };
    });

    const exportContent = {
      fileName: "DanhSachPhanPhoiTaiLieu.xlsx",
      sheet: "Sheet 1",
      content: [
        { header: "Mã tài liệu", dataIndex: "docCode" },
        { header: "Tên tài liệu", dataIndex: "Title" },
        { header: "Loại tài liệu", dataIndex: "docType" },
        { header: "Tình Trạng", dataIndex: "docStatus" },
        { header: "Ngày hiệu lực", dataIndex: "effectiveFrom" },
        { header: "SL đã đọc", dataIndex: "quantityRead" },
        { header: "Tỉ lệ đã đọc", dataIndex: "readedPercent" },
        { header: "SL chưa đọc", dataIndex: "quantityUnread" },
        { header: "Tỉ lệ chưa đọc", dataIndex: "unreadPercent" },
        { header: "Ngày ban hành", dataIndex: "createdDateTime" },
        { header: "Ngày hết hiệu lực", dataIndex: "effectiveTo" },
      ],
    };

    const worksheet = workbook.addWorksheet(exportContent.sheet);

    //* Defind colunms based on export content
    worksheet.mergeCells("A1:K2");
    worksheet.getCell("A1").value = titleOfExcelFile;
    worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
    worksheet.getCell("A1").font = { bold: true, size: 14 };

    //* Set header value row
    const headerRow = worksheet.getRow(3);
    headerRow.values = exportContent.content.map((col) => col.header);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };

    //* Add data row
    exportContent.content.forEach((_col, index) => {
      worksheet.getCell(3, index + 1).font = { bold: true };
    });

    //* Add data rows
    result.forEach((data: any) => {
      const row = exportContent.content.map((col) => data[col.dataIndex]);
      const dataRow = worksheet.addRow(row);

      dataRow.font = { bold: false };
    });

    worksheet.columns.forEach((column) => {
      if (column && column.eachCell) {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value ? cell.value.toString().length : 10;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });
        column.width = Math.min(maxLength + 2, 30);
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), exportContent.fileName);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Mã tài liệu",
      dataIndex: "docCode",
      key: "docCode",
      align: "center" as const,
      width: 200,
      ...TableHelpers.searchInput({ dataIndex: "docCode" }),
    },
    {
      title: "Tên tài liệu",
      dataIndex: "Title",
      key: "Title",
      width: 500,
      ...TableHelpers.searchInput({ dataIndex: "Title" }),
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      key: "docType",
    },
    {
      title: "Tình Trạng",
      dataIndex: "docStatus",
      key: "docStatus",
      render: (status: string, record: any) => (isDocumentExpired(record.effectiveTo) ? "Lỗi thời" : status),
      filters: [
        {
          text: "Ban hành",
          value: "publish",
        },
        {
          text: "Ban hành tạm thời",
          value: "Ban hành tạm thời",
        },
        {
          text: "Lỗi thời",
          value: "expired",
        },
      ],
      onFilter: (status: any, record) => {
        if (status === "publish") return record.docStatusValue === status && !isDocumentExpired(record.effectiveTo);
        if (status === "expired") return isDocumentExpired(record.effectiveTo);
        return record.docStatus === status;
      },
    },
    {
      title: "Ngày hiệu lực",
      dataIndex: "effectiveFrom",
      key: "effectiveFrom",
      render: (date: string) => getDDMMYYYFormat(date),
      ...TableHelpers.searchRangePicker({ dataIndex: "effectiveFrom" }),
    },

    {
      title: "SL đã đọc",
      dataIndex: "quantityRead",
      key: "quantityRead",
      render: (isRead: any, record: any) => record.docReaders?.length ?? 0,
      align: "center" as const,
    },
    {
      title: "Tỉ lệ đã đọc",
      key: "readedPercent",
      render: (data: { quantityRead: number; quantityUnread: number }, record: any): string => {
        const percentage = ((record.docReaders?.length ?? 0) / (record.docPublicEndUsers?.length ?? 1)) * 100;
        if (percentage % 1 === 0) {
          return percentage + "%";
        } else {
          return percentage.toFixed(2) + "%";
        }
      },
      align: "center" as const,
    },
    {
      title: "SL chưa đọc",
      dataIndex: "quantityUnread",
      key: "quantityUnread",
      render: (isRead: any, record: any) => (record.docPublicEndUsers?.length ?? 0) - (record.docReaders?.length ?? 0),
      align: "center" as const,
    },
    {
      title: "Tỉ lệ chưa đọc",
      key: "unreadPercent",
      render: (data: { quantityRead: number; quantityUnread: number }, record: any): string => {
        const percentage =
          (((record.docPublicEndUsers?.length ?? 0) - (record.docReaders?.length ?? 0)) /
            (record.docPublicEndUsers?.length ?? 1)) *
          100;
        if (percentage % 1 === 0) {
          return percentage + "%";
        } else {
          return percentage.toFixed(2) + "%";
        }
      },
      align: "center" as const,
    },
    {
      title: "Ngày ban hành",
      dataIndex: "createdDateTime",
      key: "createdDateTime",

      render: (date: string) => getDDMMYYYFormat(date),
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
      className: `${isColunmVisible ? "block" : "d-none"}`,
    },
    {
      title: "Ngày hết hiệu lực",
      dataIndex: "effectiveTo",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "effectiveTo",
      ...TableHelpers.searchRangePicker({ dataIndex: "effectiveTo" }),
      className: `${isColunmVisible ? "block" : "d-none"}`,
    },
  ];

  return (
    mappedData && (
      <>
        <Col sm={12} md={12} className="py-3">
          <Col sm={2} md={2} className="py-3 statistic-header">
            <div title={"Trở về trang tổng quan"} className="btnBack" onClick={() => history.goBack()}>
              <Icon.ArrowLeft />
            </div>
          </Col>
          <Col sm={10} md={10}>
            <h3>{title}</h3>
          </Col>
          <Col>
            <p>
              <i>
                Thống kê số lượng tài liệu của VIAGS và bên ngoài ban hành/cập nhật trong kỳ theo đơn vị, theo loại tài
                liệu, theo từng chủ đề
              </i>
            </p>
          </Col>
          <Box title="Bảng thống kê">
            <Col className="d-flex justify-content-center p-0">
              <div className="px-0 pb-0 modal-body">
                <div className="d-flex justify-content-end">
                  <Button className="m-1 mt-0" type="primary" onClick={handleExport}>
                    Xuất excel
                  </Button>
                </div>
                <div className="d-flex justify-content-end">
                  <Typography.Text className="mb-1 mr-3">Hiện thêm cột</Typography.Text>
                  <Checkbox checked={isColunmVisible} onChange={(value) => setColunmVisible(value.target.checked)} />
                </div>
                <Table
                  rowKey="id"
                  columns={columns}
                  showHeader={true}
                  dataSource={mappedData}
                  pagination={{
                    showTotal: (total) => `Tổng cộng: ${total}`,
                    position: ["bottomRight"],
                  }}
                />
              </div>
            </Col>
          </Box>
        </Col>
      </>
    )
  );
});
